module.exports = __webpack_public_path__ + "img/mw.mw0159b1b.svg";